"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_DOCUMENTS_SUCCEEDED = exports.GET_DOCUMENTS_FAILED = exports.GET_DOCUMENTS = exports.DOWNLOAD_FILE = void 0;
var _constants = require("../../utils/constants");
const GET_DOCUMENTS = "GET_DOCUMENTS".concat(_constants.packagePrefix);
exports.GET_DOCUMENTS = GET_DOCUMENTS;
const GET_DOCUMENTS_SUCCEEDED = "GET_DOCUMENTS".concat(_constants.packagePrefix, "_SUCCEEDED");
exports.GET_DOCUMENTS_SUCCEEDED = GET_DOCUMENTS_SUCCEEDED;
const GET_DOCUMENTS_FAILED = "GET_DOCUMENTS".concat(_constants.packagePrefix, "_FAILED");
exports.GET_DOCUMENTS_FAILED = GET_DOCUMENTS_FAILED;
const DOWNLOAD_FILE = "DOWNLOAD_FILE".concat(_constants.packagePrefix);
exports.DOWNLOAD_FILE = DOWNLOAD_FILE;